import { ref, get } from 'firebase/database';
import { database } from '../firebase';

/**
 * Finds a school ID by school name from both schools and schools_US tables
 * @param schoolName - The name of the school to search for
 * @returns Promise<string | null> - The school ID if found, null otherwise
 */
export async function findSchoolIdByName(schoolName: string): Promise<string | null> {
  if (!schoolName || schoolName.trim() === '') {
    return null;
  }

  try {
    // Search in both schools and schools_US tables
    const [schoolsSnapshot, schoolsUSSnapshot] = await Promise.all([
      get(ref(database, 'schools')),
      get(ref(database, 'schools_US'))
    ]);

    // Search in schools table
    if (schoolsSnapshot.exists()) {
      const schoolsData = schoolsSnapshot.val();
      for (const [id, data] of Object.entries(schoolsData)) {
        const school = data as any;
        if (school.SchoolName && school.SchoolName.toLowerCase().trim() === schoolName.toLowerCase().trim()) {
          return id;
        }
      }
    }

    // Search in schools_US table
    if (schoolsUSSnapshot.exists()) {
      const schoolsUSData = schoolsUSSnapshot.val();
      for (const [id, data] of Object.entries(schoolsUSData)) {
        const school = data as any;
        if (school.SchoolName && school.SchoolName.toLowerCase().trim() === schoolName.toLowerCase().trim()) {
          return id;
        }
      }
    }

    return null;
  } catch (error) {
    console.error('Error finding school ID by name:', error);
    return null;
  }
}

/**
 * Gets school data by school ID from both schools and schools_US tables
 * @param schoolId - The ID of the school to retrieve
 * @returns Promise<any | null> - The school data if found, null otherwise
 */
export async function getSchoolById(schoolId: string): Promise<any | null> {
  if (!schoolId || schoolId.trim() === '') {
    return null;
  }

  try {
    // Try schools table first
    const schoolsSnapshot = await get(ref(database, `schools/${schoolId}`));
    if (schoolsSnapshot.exists()) {
      return schoolsSnapshot.val();
    }

    // Try schools_US table
    const schoolsUSSnapshot = await get(ref(database, `schools_US/${schoolId}`));
    if (schoolsUSSnapshot.exists()) {
      return schoolsUSSnapshot.val();
    }

    return null;
  } catch (error) {
    console.error('Error getting school by ID:', error);
    return null;
  }
}



